import { useCallback, useState } from "react";

/**
 * This is used for when you have a list of items that opens the same modal when you select one
 * It helps solve the problem of keeping the previous selected value while the modal closes to avoid crashes or bad visual behaviour
 */
export default function useSelectListItemModalState(defaultValue) {
    const [modalOpen, setModalOpen] = useState(!!defaultValue);
    const [selectedValue, setSelectedValueLocal] = useState(defaultValue);

    const setSelectedValue = useCallback((value) => {
        if (!value) {
            setModalOpen(false);
        } else {
            setSelectedValueLocal(value);
            setModalOpen(true);
        }
    }, []);

    return [modalOpen, selectedValue, setSelectedValue];
}
